import { render, staticRenderFns } from "./UserTicketsTable.vue?vue&type=template&id=7030c2f9&scoped=true"
import script from "./UserTicketsTable.vue?vue&type=script&lang=js"
export * from "./UserTicketsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7030c2f9",
  null
  
)

export default component.exports